<template>
	<div class="pa-6">
		<v-card>
			<v-card-title>
				Действия
				<v-spacer></v-spacer>
			</v-card-title>

			<a-data-table
				:headers="headers"
				api-path="logs/get_action"
				disable-sort
			>
				<template v-slot:item.time="{ item }">
					{{ item.timeFormatted }}
				</template>
			</a-data-table>
		</v-card>
	</div>
</template>

<style scoped>
</style>

<script>
	import aDataTable from '../base/ADataTable.vue'

	export default {
		components: {
			aDataTable
		},
		data: () => ({
			headers: [
				{
					text: 'Время',
					value: 'time',
					align: 'center',
					filterable: true,
					filterType: 'dateTime',
				},
				{
					text: 'Пользователь',
					value: 'userName',
					align: 'center',
					filterable: true,
					filterType: 'select',
				},
				{
					text: 'Действие',
					value: 'action',
					align: 'center',
					filterable: true,
					filterType: 'select',
				},
				{
					text: 'Текст',
					value: 'text',
					align: 'center',
					filterable: true,
					filterType: 'text',
				},
			],
		}),
		methods: {

		}
	}
</script>
